import { Flex } from '@iheartjane/reefer';

import type {
  AlgoliaProduct,
  ArrayFilterValue,
  FilterGroup,
  JaneSearchState,
  ProductFilterKeys,
  RangeFilterValue,
} from '@jane/search/types';

import { FilterRanges } from './FilterRanges';
import styles from './FilterSection.module.css';
import { FilterSelections } from './FilterSelections';
import { FilterTypeahead } from './FilterTypeahead';

export interface FilterSectionProps {
  filterGroup: FilterGroup;

  /** Action when filter is changed */
  onChange: (
    key: ProductFilterKeys,
    value: ArrayFilterValue | RangeFilterValue
  ) => void;

  /** Action when filters are deselected  */
  onDeselect: (key: ProductFilterKeys) => void;

  searchState: JaneSearchState<AlgoliaProduct>;
}

export const FilterSection = ({
  filterGroup,
  onChange,
  onDeselect,
  searchState,
}: FilterSectionProps) => {
  if (filterGroup.items.length === 0) {
    return null;
  }

  const isBrandsFilter = filterGroup.label === 'Brands';

  return (
    <Flex
      background="grays-white"
      className={styles['filterSection_content']}
      pl={40}
      pr={40}
      pt={isBrandsFilter ? 20 : 40}
      pb={isBrandsFilter ? 20 : 40}
      flexDirection="column"
    >
      <FilterTypeahead filterGroup={filterGroup} />
      <FilterSelections
        filterGroup={filterGroup}
        onChange={onChange}
        onDeselect={onDeselect}
        searchState={searchState}
      />
      <FilterRanges
        filterGroup={filterGroup}
        onChange={onChange}
        onDeselect={onDeselect}
        searchState={searchState}
      />
    </Flex>
  );
};
